import { PhoneValidationStore } from '@stores/PhoneValidationStore';
import { apiResponse } from '@stores';
import { useMutation } from '@tanstack/react-query';

export class SendPhoneValidationCodeAction {
  constructor(private readonly phoneValidationStore: PhoneValidationStore = new PhoneValidationStore()) {}

  public Execute = async (phoneNumber: string) => {
    await apiResponse.handleApiResponse(async () => this.phoneValidationStore.sendCode(phoneNumber));
  };
}

export const useSendPhoneValidationCodeAction = () =>
  useMutation({
    mutationFn: async (phoneNumber: string) => {
      const action = new SendPhoneValidationCodeAction();
      return action.Execute(phoneNumber);
    },
  });
